class Mode {
    static curMode = "light";
}

export default Mode;